var exports = {
  "kL": "InlineAudioPlayer.module__container___OExxWn",
  "wx": "InlineAudioPlayer.module__header___OExxWn",
  "Rr": "InlineAudioPlayer.module__playButton___OExxWn",
  "CJ": "InlineAudioPlayer.module__playButtonIcon___OExxWn",
  "sp": "InlineAudioPlayer.module__loadingSpinnerDesktop___OExxWn",
  "t0": "InlineAudioPlayer.module__spin___OExxWn",
  "XE": "InlineAudioPlayer.module__fileInfo___OExxWn",
  "Md": "InlineAudioPlayer.module__fileName___OExxWn",
  "m$": "InlineAudioPlayer.module__fileNameTruncate___OExxWn",
  "i_": "InlineAudioPlayer.module__fileExtension___OExxWn",
  "gM": "InlineAudioPlayer.module__fileMeta___OExxWn",
  "NE": "InlineAudioPlayer.module__progressSection___OExxWn",
  "hr": "InlineAudioPlayer.module__progressBar___OExxWn",
  "Td": "InlineAudioPlayer.module__time___OExxWn",
  "ne": "InlineAudioPlayer.module__controls___OExxWn",
  "it": "InlineAudioPlayer.module__controlsLeft___OExxWn",
  "BT": "InlineAudioPlayer.module__controlsRight___OExxWn",
  "Wq": "InlineAudioPlayer.module__volumeControl___OExxWn",
  "hP": "InlineAudioPlayer.module__actionButton___OExxWn",
  "AA": "InlineAudioPlayer.module__mobileContainer___OExxWn",
  "xk": "InlineAudioPlayer.module__mobilePlayButton___OExxWn",
  "S": "InlineAudioPlayer.module__loadingSpinner___OExxWn",
  "wh": "InlineAudioPlayer.module__mobileContent___OExxWn",
  "Vg": "InlineAudioPlayer.module__mobileFileInfo___OExxWn",
  "Yg": "InlineAudioPlayer.module__mobileFileName___OExxWn",
  "kB": "InlineAudioPlayer.module__mobileFileMeta___OExxWn",
  "_S": "InlineAudioPlayer.module__mobileContainerActive___OExxWn",
  "hb": "InlineAudioPlayer.module__mobileProgressContainer___OExxWn",
  "jw": "InlineAudioPlayer.module__mobileProgressTrack___OExxWn",
  "lm": "InlineAudioPlayer.module__mobileProgressTrackActive___OExxWn",
  "$r": "InlineAudioPlayer.module__mobileProgressFill___OExxWn",
  "LI": "InlineAudioPlayer.module__mobileProgressFillActive___OExxWn",
  "zr": "InlineAudioPlayer.module__mobileTimestamp___OExxWn",
};

module.exports = exports;
